import EducatorProfileContainer from './container'

export default EducatorProfileContainer
